export default __webpack_public_path__ + "static/media/IMG_1996.9e3a548c.JPG";